define('pages/englishlive2016/viewport',['$'], function($){
    'use strict';
    var $win = $(window);
    var $nav = $('nav');
    
    return {
        get: function(){
            var navBarHeight = 0;
            $nav.each(function(i, el){
                var $el = $(el);
                if (
                    $el.css('position') == 'fixed' || 
                    $el.css('position') == 'sticky'
                ) {
                    navBarHeight += $el.outerHeight(true);
                }
            });

            return {
                top: $win.scrollTop() + navBarHeight,
                // here we use window.innerHeight cus the version of jquery we used 
                // failed to return the true height of viewport on iOS
                bottom: $win.scrollTop() + (window.innerHeight || $win.height()),
                height: $win.height() - navBarHeight
            };
        }
    };
});
